/* Grace is Green — product page behaviour.
   Variant picker, gallery, sticky bar, add-to-cart. Vanilla, no framework. */
(function () {
  'use strict';

  var root = document.querySelector('[data-gg-pdp]');
  if (!root) return;

  var dataEl = root.querySelector('[data-gg-variants]');
  var variants = [];
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    variants = [];
  }

  var moneyFormat = (window.Shopify && window.Shopify.money_format) || '€{{amount_with_comma_separator}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + whole + ',' + parts[1];
  }

  /* ------------------------------------------------------------------
     Variant selection
     ------------------------------------------------------------------ */
  var picker = root.querySelector('[data-gg-picker]');

  function currentOptions() {
    var groups = root.querySelectorAll('[data-gg-option-index]');
    var out = [];
    groups.forEach(function (group) {
      var checked = group.querySelector('input[data-gg-option-input]:checked');
      out[parseInt(group.getAttribute('data-gg-option-index'), 10)] = checked ? checked.value : null;
    });
    return out;
  }

  function findVariant(options, changedIndex) {
    var exact = variants.find(function (v) {
      return options.every(function (opt, i) {
        return opt === null || v.options[i] === opt;
      });
    });
    if (exact || changedIndex === undefined) return exact;

    // The combination does not exist (500 ml has no "2 stuks"): keep the
    // value the shopper just picked, prefer stock, then the most other
    // choices they already had.
    var best = null;
    var bestScore = -1;
    variants.forEach(function (v) {
      if (v.options[changedIndex] !== options[changedIndex]) return;
      var score = v.available ? 100 : 0;
      options.forEach(function (opt, i) {
        if (i !== changedIndex && v.options[i] === opt) score += 1;
      });
      if (score > bestScore) {
        best = v;
        bestScore = score;
      }
    });
    return best;
  }

  // Rows carry prices, savings and availability for the other options'
  // current choice, so the picker is re-rendered by the server (Section
  // Rendering API) after every change. The last request wins.
  var pickerRequest = 0;
  function refreshPicker(variant) {
    var sectionId = picker.getAttribute('data-section-id');
    if (!sectionId) return;
    var request = ++pickerRequest;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    url.searchParams.set('section_id', sectionId);
    fetch(url.toString())
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        if (request !== pickerRequest) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gg-picker]');
        if (!fresh) return;
        var active = document.activeElement;
        var focused = active && picker.contains(active) && active.matches('[data-gg-option-input]')
          ? { index: active.getAttribute('data-option-index'), value: active.value }
          : null;
        picker.innerHTML = fresh.innerHTML;
        if (focused) {
          var again = Array.prototype.find.call(
            picker.querySelectorAll('[data-option-index="' + focused.index + '"]'),
            function (input) { return input.value === focused.value; }
          );
          if (again) again.focus({ preventScroll: true });
        }
      })
      .catch(function () { /* the client-side update already happened */ });
  }

  // Check the inputs that belong to the variant actually selected.
  function syncInputs(variant) {
    picker.querySelectorAll('[data-gg-option-input]').forEach(function (input) {
      var i = parseInt(input.getAttribute('data-option-index'), 10);
      input.checked = variant.options[i] === input.value;
    });
  }

  function updateUI(variant) {
    if (!variant) return;

    // Hidden form input drives the actual add.
    var idInput = root.querySelector('[data-gg-variant-id]');
    if (idInput) idInput.value = variant.id;

    // Price block
    var priceEl = root.querySelector('[data-gg-price]');
    if (priceEl) {
      var now = priceEl.querySelector('.gg-price__now');
      var was = priceEl.querySelector('.gg-price__was');
      if (now) now.textContent = formatMoney(variant.price);
      var onSale = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
      priceEl.classList.toggle('gg-price--sale', !!onSale);
      if (was) {
        if (onSale) {
          was.textContent = formatMoney(variant.compare_at_price);
          was.hidden = false;
        } else {
          was.hidden = true;
        }
      }
      var pill = priceEl.querySelector('.gg-badge--amount');
      if (pill) {
        if (onSale) {
          pill.textContent = '−' + formatMoney(variant.compare_at_price - variant.price);
          pill.hidden = false;
        } else {
          pill.hidden = true;
        }
      }
    }

    // The price row around it: terracotta panel, "Bespaar €x" and the
    // promotion's end date only while the selected variant is on sale.
    var priceRow = root.querySelector('[data-gg-pricerow]');
    if (priceRow) {
      var rowSale = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
      priceRow.classList.toggle('gg-pdp__pricerow--sale', rowSale);
      var saving = priceRow.querySelector('[data-gg-saving]');
      if (saving) {
        saving.hidden = !rowSale;
        if (rowSale) {
          saving.textContent = (saving.getAttribute('data-template') || '')
            .replace('[amount]', formatMoney(variant.compare_at_price - variant.price));
        }
      }
      var until = priceRow.querySelector('[data-gg-until]');
      if (until) until.hidden = !rowSale;
    }

    // "Merk van de maand": the deal price follows the variant, calculated the
    // way checkout applies the automatic discount (snippets/gg-brand-deal).
    var deal = root.querySelector('[data-gg-deal]');
    var dealPrice = null;
    var dealOff = 0;
    if (deal) {
      var dealValue = parseFloat(deal.getAttribute('data-deal-value')) || 0;
      if (deal.getAttribute('data-deal-type') === 'percentage') {
        dealOff = Math.round(variant.price * dealValue / 100);
      } else {
        dealOff = Math.min(variant.price, Math.round(dealValue * 100));
      }
      dealPrice = variant.price - dealOff;
      deal.querySelectorAll('[data-gg-deal-price]').forEach(function (el) { el.textContent = formatMoney(dealPrice); });
      deal.querySelectorAll('[data-gg-deal-was]').forEach(function (el) { el.textContent = formatMoney(variant.price); });
      deal.querySelectorAll('[data-gg-deal-off]').forEach(function (el) { el.textContent = '−' + formatMoney(dealOff); });
      deal.querySelectorAll('[data-gg-deal-save]').forEach(function (el) {
        el.textContent = (el.getAttribute('data-template') || '').replace('[amount]', formatMoney(dealOff));
      });
    }

    // Stock: "Op voorraad" / "Uitverkocht" and the low-stock notice follow
    // the selected variant (levels only exist for variants at or under the
    // threshold, see the low_stock block).
    var inStock = root.querySelector('[data-gg-instock]');
    var soldOut = root.querySelector('[data-gg-oos]');
    if (inStock) inStock.hidden = !variant.available;
    if (soldOut) soldOut.hidden = !!variant.available;
    var low = root.querySelector('[data-gg-lowstock]');
    if (low) {
      var levels = {};
      try { levels = JSON.parse(low.getAttribute('data-levels') || '{}'); } catch (e) { levels = {}; }
      var left = variant.available ? levels[String(variant.id)] : 0;
      low.hidden = !left;
      var lowText = low.querySelector('[data-gg-lowstock-text]');
      if (lowText && left) {
        lowText.textContent = (low.getAttribute('data-template') || '').replace('[n]', left);
      }
    }

    // Add-to-cart button
    var atc = root.querySelector('[data-gg-atc]');
    var atcPrice = root.querySelector('[data-gg-atc-price]');
    if (atc) {
      atc.disabled = !variant.available;
      if (atcPrice) atcPrice.textContent = formatMoney(dealPrice !== null ? dealPrice : variant.price);
    }

    // Gallery labels: discount pill follows the variant; with a discount the
    // last certification gives way so there are never more than three.
    var saleLabel = root.querySelector('[data-gg-label-sale]');
    if (saleLabel) {
      // An automatic discount (deal) counts as the sale; else compare-at.
      var labelSale = dealPrice !== null ? dealOff > 0 : !!(variant.compare_at_price && variant.compare_at_price > variant.price);
      saleLabel.hidden = !labelSale;
      var saleText = saleLabel.querySelector('[data-gg-label-sale-text]');
      if (saleText && labelSale) {
        var labelPct = dealPrice !== null
          ? Math.round(dealOff * 100 / variant.price)
          : Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        saleText.textContent = '−' + labelPct + '%';
      }
      var overflow = root.querySelector('[data-gg-label-overflow]');
      if (overflow) overflow.hidden = labelSale;
    }

    // Sticky bar button follows availability, like the main button.
    var stickyAtc = root.querySelector('[data-gg-sticky-atc]');
    if (stickyAtc) {
      stickyAtc.disabled = !variant.available;
      var stickyAdd = stickyAtc.querySelector('[data-gg-sticky-add]');
      var stickyOos = stickyAtc.querySelector('[data-gg-sticky-oos]');
      if (stickyAdd) stickyAdd.hidden = !variant.available;
      if (stickyOos) stickyOos.hidden = !!variant.available;
    }

    // Sticky bar — same sale signals as the main price.
    var sv = root.querySelector('[data-gg-sticky-variant]');
    var sp = root.querySelector('[data-gg-sticky-price]');
    var sw = root.querySelector('[data-gg-sticky-was]');
    var sb = root.querySelector('[data-gg-sticky-badge]');
    var stickyNow = variant.price;
    var stickyWas = variant.compare_at_price;
    if (dealPrice !== null) {
      stickyNow = dealPrice;
      stickyWas = variant.price;
    }
    var stickySale = !!(stickyWas && stickyWas > stickyNow);
    if (sv) sv.textContent = variant.title;
    if (sp) {
      sp.textContent = formatMoney(stickyNow);
      sp.classList.toggle('gg-stickybar__price--sale', stickySale);
    }
    if (sw) {
      sw.textContent = stickySale ? formatMoney(stickyWas) : '';
      sw.hidden = !stickySale;
    }
    if (sb) {
      sb.textContent = stickySale ? '−' + formatMoney(stickyWas - stickyNow) : '';
      sb.hidden = !stickySale;
    }

    // Swatch group label reflects the chosen colour name.
    root.querySelectorAll('[data-gg-option-label]').forEach(function (el) {
      var i = parseInt(el.getAttribute('data-gg-option-label'), 10);
      if (el.closest('[data-gg-option-index]').querySelector('.gg-swatches')) {
        el.textContent = variant.options[i];
      }
    });

    // Jump the gallery to this variant's image.
    if (variant.featured_media && variant.featured_media.id) {
      var slide = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (slide && track) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    // Keep ?variant= honest without adding history entries.
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  if (picker) {
    picker.addEventListener('change', function (event) {
      if (!event.target.matches('[data-gg-option-input]')) return;
      var changed = parseInt(event.target.getAttribute('data-option-index'), 10);
      var variant = findVariant(currentOptions(), changed);
      if (!variant) return;
      syncInputs(variant);
      updateUI(variant);
      refreshPicker(variant);
    });
  }

  /* ------------------------------------------------------------------
     Gallery
     ------------------------------------------------------------------ */
  var gallery = root.querySelector('[data-gg-gallery]');
  var track = gallery && gallery.querySelector('[data-gg-gallery-track]');

  if (track) {
    var dots = gallery.querySelectorAll('[data-gg-gallery-dot]');
    var thumbs = gallery.querySelectorAll('[data-gg-gallery-thumb]');
    var slides = gallery.querySelectorAll('[data-gg-gallery-slide]');

    function goTo(index) {
      if (!slides[index]) return;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    var stage = gallery.closest('.gg-pdp__stage');
    function setActive(index) {
      // Certification labels belong to the first (packshot) photo only.
      if (stage) stage.classList.toggle('is-first-slide', index === 0);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.getAttribute('data-gg-gallery-dot'), 10));
      });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(parseInt(t.getAttribute('data-gg-gallery-thumb'), 10));
      });
    });

    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        setActive(index);
      }, 80);
    }, { passive: true });

    // Arrow keys move the carousel when it has focus.
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (event) {
      var index = Math.round(track.scrollLeft / track.clientWidth);
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(index + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(index - 1); }
    });
  }

  /* ------------------------------------------------------------------
     Quantity stepper
     ------------------------------------------------------------------ */
  root.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-gg-qty]');
    if (!btn) return;
    var input = root.querySelector('.gg-stepper__input');
    if (!input) return;
    var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-gg-qty'), 10));
    input.value = next;
  });

  /* ------------------------------------------------------------------
     Sticky bar — appears after N px of scroll
     ------------------------------------------------------------------ */
  var sticky = root.querySelector('[data-gg-sticky]');
  if (sticky) {
    var from = parseInt(sticky.getAttribute('data-from'), 10) || 600;
    var onScroll = function () { sticky.hidden = window.scrollY < from; };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var stickyBtn = sticky.querySelector('[data-gg-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var atc = root.querySelector('[data-gg-atc]');
        if (atc) atc.click();
      });
    }
  }

  /* ------------------------------------------------------------------
     "Beide toevoegen" — both line items in ONE /cart/add.js call (02 §D11)
     ------------------------------------------------------------------ */
  root.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-gg-bundle-add]');
    if (!btn) return;
    var ids = btn.getAttribute('data-gg-bundle-add').split(',').filter(Boolean);
    if (!ids.length) return;
    btn.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) }),
    })
      .then(function () {
        document.dispatchEvent(new CustomEvent('gg:cart:changed', { detail: { source: 'bundle' } }));
      })
      .finally(function () { btn.disabled = false; });
  });

  /* ------------------------------------------------------------------
     Add to cart — /cart/add.js, then hand off to the cart drawer
     ------------------------------------------------------------------ */
  var form = root.querySelector('.gg-buyform');
  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var atc = root.querySelector('[data-gg-atc]');
      var errorEl = root.querySelector('[data-gg-atc-error]');
      if (errorEl) errorEl.hidden = true;
      if (atc) atc.classList.add('is-loading');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: root.querySelector('[data-gg-variant-id]').value,
            quantity: parseInt((root.querySelector('.gg-stepper__input') || {}).value || 1, 10),
          }],
        }),
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Error');
          document.dispatchEvent(new CustomEvent('gg:cart:changed', { detail: { source: 'pdp' } }));
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = err.message;
            errorEl.hidden = false;
          }
        })
        .finally(function () {
          if (atc) atc.classList.remove('is-loading');
        });
    });
  }
})();
